import { TRect } from '@/types';

export function isValidBbox(bbox: TRect | undefined | null): bbox is TRect {
  if (!bbox || !Array.isArray(bbox) || bbox.length !== 4) return false;
  const [left, top, right, bottom] = bbox;
  return (
    [left, top, right, bottom].every(v => isFinite(v) && v >= 0 && v <= 1) &&
    right > left &&
    bottom > top
  );
}
